var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({staticClass:"small-dot",attrs:{"color":_vm.dotColor,"size":"12"}},'v-icon',attrs,false),on),[_vm._v(" mdi-circle ")])]}}])},[_c('span',{staticClass:"smaller-tooltip"},[_vm._v(_vm._s(_vm.tooltipText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }